import {ACTION_CODE} from './_actionCode';
import {InvoiceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'UPDATE_INVOICE';

export async function updateInvoiceById(
    userData: Record<string, any>,
    invoiceId: number,
    payloadUpdate: Record<string, any>
) {
    try {
        LoggerService.logInfo('Action - updateInvoiceById - Start');

        const updateInvoiceByIdResult =
            await InvoiceService.updateInvoiceById(userData, invoiceId, payloadUpdate);

        LoggerService.logInfo('Action - updateInvoiceById - End - Success');

        return ResultModel.newSuccessResult(updateInvoiceByIdResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - updateInvoiceById - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: getErrorMessage(error, 'Erreur de mise à jour d\'une facture'),
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}

function getErrorMessage(error: unknown, fallback: string) {
    if (error && typeof error === 'object') {
        const message = (error as {message?: unknown}).message;

        if (typeof message === 'string') {
            return message;
        }
    }

    return fallback;
}
